;(function() {
  'use strict'

  var dependencies = []

  angular.module('app.messageCloseDialog', dependencies)
})()
